import type * as React from 'react'
import { Authenticator } from '@aws-amplify/ui-react'
import { startAmplifyOnce } from '../utils'

interface Props {
    children: React.ReactNode
}

export const CognitoAuthProvider: React.VFC<Props> = ({ children }: Props) => {
    startAmplifyOnce()

    return <Authenticator.Provider>{children}</Authenticator.Provider>
}
